import { useEffect } from 'react';
import { useUiStore } from '@/stores/uiStore';

/** Binds ⌘K / Ctrl+K to toggle the global command palette. */
export function useCommandShortcut() {
  const toggle = useUiStore((state) => state.toggleCommandPalette);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        toggle();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [toggle]);
}
